import {Component, OnInit} from "@angular/core";
import {DossierService} from "../../../../../services";
import {DictType} from "../../../../../models/dossier";
import {DictionaryService} from "@amlCore/services";
import {DossierBaseModel} from "../../dossierBaseModel";
import {DossierAccessEnum} from "@amlCore/enums";
import {DossierBaseSubComponent} from "../dossierBaseSub.component";
import {AlertPanelService} from "@amlCore/components";
import {Unsubscribable} from "rxjs";
import {pairwise, startWith} from "rxjs/operators";

@Component({
  selector: 'app-residence-doc-info-dossier',
  styleUrls: ['../../dossier.css'],
  templateUrl: './residenceDocInfoDossier.component.html'
})
export class ResidenceDocInfoDossierComponent extends DossierBaseSubComponent implements OnInit {

  docTypeList: Array<DictType> = [];
  // Обязательность полей по типу вкладки
  isFieldsReq = false;
  isValidDocShow: boolean;
  isKodPodrShow: boolean;
  validDocList: Array<DictType> = [];
  private docTypeValueChanges: Unsubscribable;

  constructor(protected dossierService: DossierService, protected dictSrv: DictionaryService,
              protected dossierBaseModel: DossierBaseModel,
              protected alertPanelService: AlertPanelService) {
    super(dossierService, dictSrv, alertPanelService);
  }

  ngOnInit() {
    this.validDocList = this.getStaticData('validDoc');
    this.dictSrv.getRemoteDataCodeSort('staydocname').then((result) => {
      this.docTypeList = result;
    });
    this.isFieldsReq = ![DossierAccessEnum.SVEDAU,
      DossierAccessEnum.SVEDUDS,
      DossierAccessEnum.SVEDVPR,
      DossierAccessEnum.SVEDBV].includes(this.typePage);

    this.initDocType(this.f('docType').value);
    this.docTypeValueChanges = this.f('docType').valueChanges.pipe(startWith(<string>null), pairwise()).subscribe(([prev, next]: [DictType, DictType]) => {
      this.initDocType(next);
    });
    this.addUnsubscribable(this.docTypeValueChanges);

  }

  private initDocType(value: DictType){
    if (!this.formGroupApp.disabled) {
      const docOtherControl = this.f('docOther');
      const kodPodrControl = this.f('kodPodr');
      const validDocControl = this.f('validDoc');
      setTimeout(() => {
        docOtherControl.disable({onlySelf: true});
        kodPodrControl.disable({onlySelf: true});
        validDocControl.disable();
      });

      if (value?.code == '99') {
        setTimeout(() => {
          docOtherControl.enable({onlySelf: true});
        });
      }
      if (this.isKodPodrEnabled(value?.code)) {
        setTimeout(() => {
          kodPodrControl.enable();
        });
      }
      if (this.isValidDocEnabled(value?.code)) {
        setTimeout(() => {
          validDocControl.enable();
        });
      }
    }
  }


  isKodPodrEnabled(docTypeCode?: string): boolean{
    this.isKodPodrShow = docTypeCode === '3';
    return this.isKodPodrShow;
  }

  isOrganRequired(docType: string) {
    return docType && !['5', '6'].includes(docType);
  }

  isValidDocEnabled(docTypeCode?: string): boolean{
    this.isValidDocShow =  ['1', '2', '3', '4', '7', '8'].includes(docTypeCode);
    return this.isValidDocShow;
  }
}
